import React, { Component } from 'react';
import moment from 'moment';

// Components
import { FormattedNumber } from 'react-intl';

// Consts
import {
  scheduleStatusToLabel,
  scheduleTypesToLabel,
} from '../../../../../util/scheduling';

// css
import './styles.css';

export default class ScheduleTableBody extends Component {
  _renderCellClasses = (cellIndex) => {
    const { headers } = this.props;
    const header = headers[cellIndex];

    return `
      ScheduleTableBody__cell
      ScheduleTableBody__cell--${header.alignment}
      ${header.highlighted ? 'ScheduleTableBody__cell--highlighted' : ''}
    `;
  };

  _renderFormattedNumber = (value, style, currency) => (
    <FormattedNumber
      style={style}
      currency={currency ? 'currency' : ''}
      minimumFractionDigits={2}
      maximumFractionDigits={2}
      value={value}
    />
  );

  render() {
    const { data } = this.props;

    return (
      <tbody className="ScheduleTableBody">
        {data.scheduleList.map(schedule => (
          <tr
            key={schedule.id}
            className="ScheduleTableBody__row"
            onClick={() => {
              this.props.onTableItemClick(schedule);
            }}
          >
            <td className={this._renderCellClasses(0)}>{schedule.id}</td>
            <td className={this._renderCellClasses(1)}>{schedule.warehouse}</td>
            <td className={this._renderCellClasses(2)}>
              {scheduleTypesToLabel[schedule.scheduleType]}
            </td>
            <td className={this._renderCellClasses(3)}>
              {moment(schedule.startDate).format('DD/MM/YYYY')}
            </td>
            <td className={this._renderCellClasses(4)}>{schedule.dock}</td>
            <td className={this._renderCellClasses(5)}>{schedule.client}</td>
            <td className={this._renderCellClasses(6)}>{schedule.nfCount}</td>
            <td className={this._renderCellClasses(7)}>
              {schedule.totalVolumes}
            </td>
            <td className={this._renderCellClasses(8)}>
              {this._renderFormattedNumber(schedule.totalWeight, 'decimal')}
            </td>
            <td className={this._renderCellClasses(9)}>
              {this._renderFormattedNumber(
                schedule.totalValue,
                'currency',
                true,
              )}
            </td>
            <td className={this._renderCellClasses(10)}>
              {schedule.driverName}
            </td>
            <td className={this._renderCellClasses(11)}>{schedule.plate}</td>
            <td className={this._renderCellClasses(12)}>
              {scheduleStatusToLabel[schedule.status]}
            </td>
          </tr>
        ))}
      </tbody>
    );
  }
}
